import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationDatahubService } from '../../nav/service/navigation-datahub.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { DatePipe } from '@angular/common';
import { LoadingphaseService } from '../../nav/service/loadingphase.service';
import { UiMessageSnackService } from '../../core/components/message-snack/service/message-snack.service';

@Component({
  selector: 'app-fg-select-popup',
  templateUrl: './fg-select-popup.component.html',
  styleUrls: ['./fg-select-popup.component.scss']
})
export class FgSelectPopupComponent implements OnInit {

  public inputValue = '';
  public searchCols = ['bezeichnung', 'anmerkung', 'manuell', 'add'];
  public selectCols = ['remove', 'kennung', 'anmerkung', 'manuell'];

  public searchresult = new MatTableDataSource<IFgDisplay>([]);
  public selected = new MatTableDataSource<IFgDisplay>([]);
  private allFg: IFgDisplay[] = [];

  @ViewChild('searchPaginator') searchPaginator: MatPaginator;
  @ViewChild('selectPaginator') selectPaginator: MatPaginator;
  constructor(
    private dialogRef: MatDialogRef<FgSelectPopupComponent>,
    private navService: NavigationDatahubService,
    private _datePipe: DatePipe,
    private _messageService: UiMessageSnackService,
    private _loadingphaseService: LoadingphaseService,
  ) {

  }

  ngOnInit() {
    this.navService.findDocumentOfCollection('Funktionsgruppe', {}).then(
      (data) => {
        this.allFg = data.filter((v) => v.manuell);
        this.inputChanged();
      }
    );
    this.searchresult.paginator = this.selectPaginator;
    this.selected.paginator = this.selectPaginator;
  }

  public set loadingPhase(value: boolean) {
    this._loadingphaseService.setLoadingphase(value, 'fg_select_popup');
  }

  public inputChanged() {
    let filtered: IFgDisplay[];

    if (!this.inputValue) {
      filtered = this.allFg;
    } else {
      filtered = this.allFg.filter(({ bezeichnung }) => bezeichnung.includes(this.inputValue));
    }

    this.updateSearch(filtered.filter(({ _id }) => !this.selected.data.some((elem) => elem._id === _id)));
  }

  public addFg(element: IFgDisplay) {
    const data = [...this.selected.data, element];
    this.updateSelected(data);
    this.updateSearch(this.searchresult.data.filter(({ _id }) => _id !== element._id));
  }

  public removeFg(element: IFgDisplay) {
    const data = [...this.searchresult.data, element];
    this.updateSelected(this.selected.data.filter(({ _id }) => _id !== element._id));
    this.updateSearch(data);
  }

  public download() {
    this.loadingPhase = true;
    this.navService.postManualChecklist(this.selected.data.map(({ _id }) => _id)).then(
      (res) => {
        const date = Date.now();
        const blob = new Blob([(res)], { type: 'application/xlsx' });
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${this._datePipe.transform(date, 'yyyy-MM-dd_hh-mm-ss')}_Prüfliste_manuelle_Entrauchungen.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.loadingPhase = false;
      },
      (err) => {
        this._messageService.logMessage('ERROR', { uiMessage: err.message || 'Fehler bei der Generierung!' });
        this.loadingPhase = false;
      }).catch(() => {
        this._messageService.logMessage('ERROR', { uiMessage: 'Fehler bei der Generierung!' });
        this.loadingPhase = false;
      });
  }

  public close() {
    this.dialogRef.close();
  }

  private updateSearch(array: IFgDisplay[]) {
    this.searchresult = new MatTableDataSource(array);
    this.searchresult.paginator = this.searchPaginator;
  }

  private updateSelected(array: IFgDisplay[]) {
    this.selected = new MatTableDataSource(array);
    this.selected.paginator = this.selectPaginator;
  }

}

interface IFgDisplay {
  _id: string;
  bezeichnung: string;
  manuell: boolean;
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/menu/fg-select-popup/fg-select-popup.component.ts